import { createApi } from '@thinknimble/tn-models'
import { axiosInstance } from '../axios-instance'
import { vendorCreateShape, vendorFilterShape, vendorShape } from './models'

export const vendorApi = createApi({
  client: axiosInstance,
  baseUri: '/expenses/vendors/',
  models: {
    entity: vendorShape,
    create: vendorCreateShape,
    extraFilters: vendorFilterShape,
  },
})
